import React from 'react'

import { ProductFeatureCard } from 'components/product-feature-card/ProductFeatureCard'
import { Content } from 'sdk/components'

import type { SdkResourceCardCmsContent } from 'core/services/cms/interfaces'

import styles from './style.module.scss'

interface ResourceDownloadCardsProps {
  cards: SdkResourceCardCmsContent[]
}

export const ResourceDownloadCards: React.FC<ResourceDownloadCardsProps> = ({ cards }) => {
  return (
    <Content className={styles.featureCardsContainer}>
      {cards.map((card, index) => (
        <ProductFeatureCard
          key={index}
          icon={card.iconUrl}
          text={card.text}
          buttonText={card.buttonText}
          href={card.href}
          target="_blank"
          row
          className={styles.featureCard}
        />
      ))}
    </Content>
  )
}
